module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chaptitler-a"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Old Japan")])]), _vm._v(" "), _c('h3', {
    staticClass: "chaptitle1-a2",
    attrs: {
      "id": "ch2-6"
    }
  }, [_vm._v("THE JUDGMENT OF OKA TADASUKE"), _c('a', {
    attrs: {
      "href": "#/xhtml/15_Chapter026#rch2fn6",
      "id": "ch2fn6"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-as1"
  }, [_vm._v("Considered the ideal judge of Japanese justice in the early 1700’s Oka Tadasuke, Baron Echizen is presented as having the wisdom and fame of Solomon. There is still in existence a popular book containing stories showing his excellent insight and shrewd justice. The following anecdote is almost a duplicate of that of Solomon’s judgment upon two women who claim the same child.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About a century and a half ago, a woman who was acting as a servant in the house of a certain Baron had a little girl born to her. Finding it difficult to attend to the child properly while in service, she put it out to nurse in a neighboring village, and paid a fixed sum per month for its maintenance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the child reached the age of ten, the mother, having finished the term of her service, left the Baron’s mansion. Being now her own mistress, and naturally wishing to have the child with her, she informed the woman who had it that she wanted the child. But the woman was reluctant to part with her. The child was very intelligent, and the foster-mother thought that she might get some money by hiring her out. So she refused to give her up to the mother. This of course led to a quarrel. The disputants went to law about it; and the case came up before Oka Tadasuke, then Magistrate of Yedo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman to whom the child had been intrusted asserted that it was her own offspring, and that the other woman was a pretender. Oka saw that the dispute was a difficult one to "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("decide by ordinary methods. So he commanded the women to place the child between them, one to take hold of its right hand and the other of its left, and each to pull with all her might. “The one who is victorious,” said the Magistrate, “shall be declared the true mother.” The real mother did not relish this mode of settling the dispute; and though she did as she was bidden and took hold of the child’s hand, she did what she could to prevent the child from being hurt, and slackened her hold as soon as the foster-mother began to pull, thus giving her an easy victory. “There!” said the foster mother, “the child, you see, is mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Oka interposed: “You are a deceiver. The real mother, I perceive, is the one who relaxed her grasp on the child, fearing to hurt her. But you thought only of winning in the struggle, and cared nothing for the feelings of the child. You are not the true mother”; and he ordered her to be bound. She immediately confessed her attempt to deceive and begged for pardon. And the people who looked on said “The judgment is indeed founded on a knowledge of human nature.”")]), _vm._v(" "), _c('p', {
    staticClass: "note-a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_Chapter026#ch2fn6",
      "id": "rch2fn6"
    }
  }, [_vm._v("*")]), _vm._v(" From J. H. Wigmore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Legal Systems of Old Japan")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58262c34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/15_Chapter026.vue
// module id = 111
// module chunks = 0